import config from "../config";
import request, { requestOptions } from "../utils/request";

const baseUrl = `${config.API_ROOT}/account`;

const Account = {
  createAccount: async ({ account }) => {
    const options = await requestOptions("POST", { account }, true);
    const url = `${baseUrl}/create-new-account`;
    return request(url, options);
  },
  lisInvites: async () => {
    const options = await requestOptions("GET", {}, true);
    const url = `${baseUrl}/list-invites`;
    return request(url, options);
  },
  getInvite: async (token) => {
    const options = await requestOptions("POST", { token }, true);
    const url = `${baseUrl}/get-invite`;
    return request(url, options);
  },
  acceptInvite: async (id) => {
    const options = await requestOptions("POST", { id }, true);
    const url = `${baseUrl}/accept-invite`;
    return request(url, options);
  },
};

export default Account;
